import script from "./VitaBeruCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./VitaBeruCard.vue?vue&type=script&setup=true&lang=ts"

import "./VitaBeruCard.vue?vue&type=style&index=0&id=2d4841ab&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d4841ab"]])

export default __exports__